import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMap from 'highcharts/modules/map';
import { moneyFormatter } from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { ID_ALL } from '../../constant/city';
import { API } from '../../api/api';
import { getTahun } from '../../utils/Filter';
import EmptyData from './EmptyData';

highchartsMap(Highcharts);

const FindPriceLocation = () => {
  const dispatch = useDispatch();
  const { chart, selected_cari_harga } = useSelector((state) => state.checkPriceReducer);
  const [loggedIn, setLoggedIn] = useState(false);
  const [yearList, setYearList] = useState([{ value: '2004', label: '2004' }]);

  // year options will be between selected start year to end year
  function filterByYear(value) {
    return value.value >= selected_cari_harga.startYear && value.value <= selected_cari_harga.endYear;
  }
  useEffect(() => {
    getTahun(
      selected_cari_harga.brand,
      selected_cari_harga.series,
      selected_cari_harga.tipe,
      selected_cari_harga.silinder
    ).then((res) => setYearList(res.filter(filterByYear)));
  }, []);

  const regions = [
    'id-indo',
    'id-aceh',
    'id-kaltim',
    'SEMARANG',
    'id-bengkulu',
    'BANTEN',
    'id-kalbar',
    'id-belitung',
    'BALI',
    'SURABAYA',
    'id-kalsel',
    'id-ntt',
    'MAKASSAR',
    'id-kriau',
    'id-irian',
    'MEDAN',
    'PEKANBARU',
    'id-sulut',
    'id-malut',
    'id-sumbar',
    'id-maluku',
    'id-ntb',
    'id-sultra',
    'id-sulteng',
    'id-papua',
    'BANDUNG',
    'LAMPUNG',
    'JAKARTA',
    'id-gorontalo',
    'id-yogya',
    'id-kalteng',
    'PALEMBANG',
    'id-sulbar',
    'JAMBI',
  ];

  useEffect(() => {
    if (localStorage.getItem('id') != null) {
      setLoggedIn(true);
    }
  }, []);

  function onChangeYear(event) {
    axios
      .get(API.service.area_city, {
        params: {
          ...selected_cari_harga,
          year: event.target.value,
        },
      })
      .then((res) => {
        const data = res.data.data;
        let series3 =
          data.item.length > 0
            ? regions.map((region) => {
                const { hargaTerendah, hargaTertinggi } = data.item.find((e) => e.lokasi == region) || {
                  hargaTerendah: null,
                  hargaTertinggi: null,
                };
                return {
                  'hc-key': region,
                  value: hargaTertinggi ? parseInt(hargaTertinggi) : null,
                  valueMin: hargaTerendah ? parseInt(hargaTerendah) : null,
                };
              })
            : null;

        dispatch({
          type: 'SET_CHART',
          value: {
            ...chart,
            chart3: {
              series: series3,
              title: data.title,
            },
          },
        });
      });
  }

  const options = {
    chart: {
      map: ID_ALL,
      renderTo: 'chart3',
    },
    title: {
      text: chart.chart3 ? chart.chart3.title : '',
    },
    plotOptions: {
      map: {
        states: {
          hover: {
            color: '#f0a18c',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    colorAxis: {
      minColor: '#9CCDE2',
      maxColor: '#182361',
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    legend: {
      title: {
        text: 'Index Penjualan',
      },
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      floating: false,
    },
    subtitle: {
      text: 'Harga Terbentuk Berdasarkan Lokasi',
      style: {
        fontSize: '12px',
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const defaultPoint = {
          valueMin: 0,
          value: 0,
        };
        let { valueMin, value } = typeof this.point === 'undefined' ? defaultPoint : this.point;
        return (
          `<span style="font-size:12px; font-weight: bold">${
            typeof this.key === 'undefined' ? 'Loading..' : this.key
          }</span><table>` +
          `<tr style="font-size: 14px">
                  <td style="padding:0">Harga Termahal</td>
                  <td style="padding:0px 5px;">: ${moneyFormatter(value)}</td>
              </tr>
              <tr style="font-size: 14px">
                  <td style="padding:0">Harga Termurah</td>
                  <td style="padding:0px 5px;">: ${moneyFormatter(valueMin)}</td>
              </tr></table>`
        );
      },
    },
    mapNavigation: {
      enableButtons: false,
      enableDoubleClickZoomTo: true,
      enableMouseWheelZoom: true,
    },
    series: [
      {
        mapData: ID_ALL,
        data: loggedIn ? (chart.chart3 && chart.chart3.series ? [...chart.chart3.series] : []) : [],
        keys: ['hc-key', 'value', 'valueMin'],
      },
    ],
  };

  return (
    <div id="chart3" className="col-xl-12">
      {selected_cari_harga.startYear !== selected_cari_harga.endYear && (
        <div className="w-100 d-flex align-items-center justify-content-end p-2">
          <select className="filter-year" onChange={(e) => onChangeYear(e)}>
            {yearList.map((item, index) => {
              return (
                <option
                  value={item.value}
                  key={index}
                  selected={selected_cari_harga.year === item.value}
                  disabled={item.value === 'label'}
                >
                  {item.label}
                </option>
              );
            })}
          </select>
        </div>
      )}

      {chart.chart3.series ? (
        <HighchartsReact highcharts={Highcharts} constructorType={'mapChart'} options={options} />
      ) : (
        <EmptyData title={options.title.text} subTitle={options.subtitle.text} />
      )}
    </div>
  );
};

export default FindPriceLocation;

// import React from "react";
// import { render } from "react-dom";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import highchartsMap from "highcharts/modules/map";
// //import proj4 from "./proj4";
// import mapDataIE from "@highcharts/map-collection/countries/id/id-all.geo.json";
// highchartsMap(Highcharts); // Initialize the map module

// const mapOptions = {
//   chart: {
//     map: "countries/id/id-all",
//   },

//   title: {
//     text: "Toyota Avanza E 1.3 2014",
//     style: {
//       fontSize: "15px",
//       fontWeight: "bold",
//       color: "#123E69",
//     },
//   },
//   subtitle: {
//     text: "Harga Terbentuk ( Min Max ) Berdasarkan Lokasi",
//   },

//   credits: {
//     enabled: false,
//   },
//   mapNavigation: {
//     enabled: false,
//   },
//   tooltip: {
//     headerFormat: "",
//     pointFormat: "lat: {point.lat}, lon: {point.lon}",
//   },
//   series: [
//     {
//       // Use the gb-all map with no data as a basemap
//       name: "Basemap",
//       mapData: mapDataIE,
//       borderColor: "#A0A0A0",
//       nullColor: "rgba(200, 200, 200, 0.3)",
//       showInLegend: false,
//     },
//   ],
// };

// const App = () => (
//   <div className="col-12 py-5 align-items-lg-center">
//     <HighchartsReact
//       constructorType={"mapChart"}
//       highcharts={Highcharts}
//       options={mapOptions}
//     />
//   </div>
// );

// export default App;
